import { DatabaseZap, CheckCircle2 } from "lucide-react";
import { getInfo, useDataVersion } from "@/data/store";

/** Banner discret care marchează clar sursa datelor (demo mock vs. date importate). */
export function MockBanner() {
  useDataVersion(); // se actualizează la orice import / revenire la demo
  const info = getInfo();
  const esteImport = info.mode === "imported";
  const generat = info.importedAt ? new Date(info.importedAt) : null;

  return (
    <div
      className={
        esteImport
          ? "flex items-start gap-2 rounded-lg border border-emerald-200 bg-emerald-50 px-3 py-2 text-xs leading-relaxed text-emerald-800"
          : "flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-xs leading-relaxed text-amber-800"
      }
    >
      {esteImport ? (
        <CheckCircle2 className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      ) : (
        <DatabaseZap className="mt-0.5 h-3.5 w-3.5 shrink-0" />
      )}
      <span className="min-w-0">
        {esteImport ? (
          <>
            <strong>Date importate</strong> ({info.importedKeys.length} seturi)
            {generat && <> · {generat.toLocaleDateString("ro-RO")}</>}. Sursă: exporturile tale
            Excel/CSV.
          </>
        ) : (
          <>
            <strong>Date DEMO</strong> (mock, reper ~200 €/oră). Apasă{" "}
            <strong>„Importă date"</strong> ca să încarci exporturile tale reale WinMentor/Optima.
          </>
        )}
      </span>
    </div>
  );
}
